import React from "react";
export const Spinner = () => {
  return <div>Spinner</div>;
};
